import React from 'react';
import BlogHero from '../BlogComponents/BlogHero'
import Footer from '../components/Footer';
import BehindTheReviews from '../BlogComponents/BehindTheReviews';


function Blog() {
  return (
    <>
      <BlogHero />
      <BehindTheReviews/>
      <Footer/>

    </>
  );
}

export default Blog;
